import styled from 'styled-components';

export const LeadBoxFechadoContainer = styled.div`
    width: 360px;
    height: fit-content;
    padding: ${(props) => (props.onDialog ? '20px' : '0 20px 20px 20px')};
    border-radius: ${(props) => (props.onDialog ? '' : '4px')};
    box-shadow: ${(props) =>
        props.onDialog ? '' : '0 0 4px 0 rgba(0, 0, 0, 0.7)'};
    background-color: #fff;

    @media (max-width: 768px) {
        margin: ${(props) => (props.onDialog ? '' : '10% auto')};
        width: 100%;
    }
`;

export const LeadBoxFechadoWrapperDesktop = styled.div`
    display: block;
    @media (max-width: 768px) {
        display: none;
    }
`;

export const LeadBoxFechadoWrapperMobile = styled.div`
    display: none;
    @media (max-width: 768px) {
        display: block;
    }
`;

export const BotaoRetornar = styled.button`
    background: transparent;
    border: transparent;
    cursor: pointer;
`;

export const FormContatoHeader = styled.div`
    display: ${(props) => (props.onDialog ? 'none' : 'flex')};
    flex-direction: row;
    padding: 15px 0;
    align-items: center;
`;

export const FormContatoHeaderTexto = styled.p`
    color: #3f8eb5;
    margin-left: 10px;
`;

export const BoxFeedBackImagem = styled.div`
    padding: 30px 0;
`;
